import { render, staticRenderFns } from "./ReadMoreOnCarbon.vue?vue&type=template&id=54777b32&scoped=true&"
import script from "./ReadMoreOnCarbon.vue?vue&type=script&setup=true&lang=js&"
export * from "./ReadMoreOnCarbon.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54777b32",
  null
  
)

export default component.exports